require('./brokerMarketsIndexesView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');
const { BrokerAccordionIndexes } = require('./brokerAccordionIndexes/brokerAccordionIndexes');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { buildArrowIcon } = require('utilities/brokerMarketsHelper')

// @constants
const BREADCRUMB = [
    {
        text: <FormattedText value="brokerMarketNews-savingsTitlte" />,
        url: '/myprofile/broker'
    },
    {
        text: <FormattedText value="broker-marketsTitle" />,
        url: '/myprofile/broker/markets'
    },
    {
        text: <FormattedText value="brokerMarketNews-allIndexesValuesTitle" />,
        url: ''
    }
];

class BrokerMarketsIndexesView extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            selectedTab: 0,
            selectedTabName: '',
            filterSelected: 4,
            endDate: null
        }
    }

    componentDidMount() {
        const { immBrokerExchangeIndexes, getIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('indexes').size === 0)
            getIndexes();
    }

    buildTabs = () => {
        const { immBrokerExchangeIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('indexes') && immBrokerExchangeIndexes.get('indexes').size > 0) {

            return (immBrokerExchangeIndexes.get('indexes').toJS().map((data) => {
                return ({
                    label: data.instrumentTranslated,
                    content: this.buildPrimaryIndexes(data),
                })
            }))
        }

        return null;
    }

    buildPrimaryIndexes = (data) => {
        const { originCountry } = this.props;
        return (
            <BrokerAccordionIndexes
                buildArrowIcon={buildArrowIcon}
                originCountry={originCountry}
                dataChart={data}
            />
        )
    }

    handleChangeTab = (selectedTab) => {
        const { immBrokerExchangeIndexes } = this.props;

        this.setState({
            selectedTab,
            selectedTabName: immBrokerExchangeIndexes.get('indexes').toJS()[selectedTab].name
        })
    }

    buildTabbedBox = () => {
        const { selectedTab } = this.state;
        const { immBrokerExchangeIndexes } = this.props;
        const indexes = this.buildTabs();

        if (immBrokerExchangeIndexes.get('indexes') && immBrokerExchangeIndexes.get('indexes').size > 0) {
            return (<TabbedBox
                onlyTabs
                onlyContent
                id="brokerIndexes"
                tabs={indexes}
                left={true}
                onTabSelection={this.handleChangeTab}
                activeTab={selectedTab}
            />)
        }

        return null;
    }

    buildIndexesSections = () => {
        const { immBrokerExchangeIndexes  } = this.props;
        const loading = immBrokerExchangeIndexes.get('isFetching');
        const error = immBrokerExchangeIndexes.get('errorReceived');

        return (
            <OKLoadingErrorMessage
                isLoading={loading}
                isError={error}
            >
                {this.buildTabbedBox()}
            </OKLoadingErrorMessage>
        );
    }

    render() {
        const tableIndexes = this.buildIndexesSections();

        return (
            <div className="broker-markets-indexes">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={BREADCRUMB}
                                finalTitle={<FormattedText value="brokerMarketNews-indexesValuesTitle" />}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>

                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="broker-markets-indexes__container">
                                <OKBoxSectionContent
                                    content={
                                        tableIndexes
                                    }
                                    hasFooter
                                    footerContentLeft={
                                        <Link className="broker-markets-indexes__container__link-footer" to="/myprofile/broker/markets">
                                            <FormattedText value="brokerMarketNews-returnMarketsNews" />
                                        </Link>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsIndexesView.propTypes = {
    immBrokerMarket: PropTypes.object,
    requestIndexesData: PropTypes.func,
    requestIndexesDataMedysif: PropTypes.func,
    requestIndexesHistoricalDataMedysif: PropTypes.func,
    getIndexes: PropTypes.func,
    immBrokerExchangeIndexes: PropTypes.object,
    immBrokerAllIndexes: PropTypes.object,
    originCountry: PropTypes.object,
};

module.exports.constructor = BrokerMarketsIndexesView;
module.exports.BrokerMarketsIndexesView = connect(
    state => ({
        immBrokerMarket: state.brokerMarkets,
        immBrokerExchangeIndexes: state.brokerExchangeIndexes,
        immBrokerAllIndexes: state.brokerAllIndexes,
        originCountry: state.profile.get('originCountry')
    }), {
        requestIndexesData: brokerMarketsActions.requestIndexesData,
        requestIndexesDataMedysif: brokerMarketsActions.requestIndexesDataMedysif,
        requestIndexesHistoricalDataMedysif: brokerMarketsActions.requestIndexesHistoricalDataMedysif,
        getStocksByIndex: brokerTodaysMainStocksActions.getStocksByIndex,
        getIndexes: brokerTodaysMainStocksActions.getIndexes
})(BrokerMarketsIndexesView);
